import { render, staticRenderFns } from "./vfooter.vue?vue&type=template&id=35ee2c90&scoped=true&"
import script from "./vfooter.vue?vue&type=script&lang=js&"
export * from "./vfooter.vue?vue&type=script&lang=js&"
import style0 from "./vfooter.vue?vue&type=style&index=0&id=35ee2c90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ee2c90",
  null
  
)

export default component.exports